// @flow
import { noop } from 'lodash';

import { API_CALL, CLEAR_FRIEND_SEARCH_RESULTS } from '../constants/actionTypes';
import * as friendsApi from '../api/friends';
import { SEARCH_USER } from '../constants/apiTypes';

export function searchUsers(searchTerm: string, searchId?: string | number) {
  // at the moment we allow users to create usernames with any
  // number of characters (e.g. 1 character). So just always fire the search.

  if (!searchTerm) {
    return noop;
  }

  return {
    type: API_CALL,
    api: SEARCH_USER,
    request: friendsApi.searchUsers({ q: searchTerm }).then(result => ({
      users: result.data
    })),
    searchId
  };
}

export function clearResults(searchId?: string | number) {
  return {
    type: CLEAR_FRIEND_SEARCH_RESULTS,
    searchId
  };
}
